import { AIConfiguredModelProviders } from "@graylog/enterprise-api";
import { toProviderAuth } from "ai-management/providerAuth";
import { MODEL_PROVIDER_CONFIG_QUERY_KEY } from "ai-management/hooks/useModelProviderConfig";
export const MODEL_PROVIDERS_QUERY_KEY = ["ai-management", "model-providers"];
export const keyFn = (searchParams) => [...MODEL_PROVIDERS_QUERY_KEY, "list", searchParams];
export const toConfiguredModelProvider = ({
  used_by: _usedBy,
  auth,
  ...provider
}) => ({ ...provider, auth: toProviderAuth(auth) });
export const invalidateModelProviders = (queryClient) => Promise.all([
  queryClient.invalidateQueries({ queryKey: MODEL_PROVIDERS_QUERY_KEY }),
  queryClient.invalidateQueries({ queryKey: MODEL_PROVIDER_CONFIG_QUERY_KEY })
]);
const fetchModelProviders = (searchParams) => AIConfiguredModelProviders.listConfiguredProviders(
  searchParams.query,
  searchParams.sort.attributeId,
  searchParams.sort.direction
).then(({ elements, attributes }) => ({
  list: elements.map(toConfiguredModelProvider),
  attributes,
  pagination: {
    count: elements.length,
    total: elements.length,
    page: 1,
    perPage: searchParams.pageSize,
    query: searchParams.query
  }
}));
export default fetchModelProviders;
